import config from '@/config'
import { TimeFrame } from '@/models/Leaderboard'
import { isGokollab } from '@ghl/clientportal-core/init'
import { requests } from './HTTPService'

export const GokollabService = {
  getUserLocation: async (): Promise<any> => {
    if (!isGokollab()) {
      return null
    }
    return (
      await requests().get(
        `${config.GOKOLLAB_SERVER_URL}/locations/user`
      )
    ).data
  },
  getGokollabContactId: async (
    locationId: string,
    contactId: string
  ): Promise<any> => {
    return (
      await requests().get(
        `${config.GOKOLLAB_SERVER_URL}/${locationId}/users/gokollab-contact-id/${contactId}?forceCreate=true`
      )
    ).data
  },
  generateInvitationLink: async (
    locationId: string,
    groupId: string
  ): Promise<any> => {
    return (
      await requests().post(
        `${config.GOKOLLAB_SERVER_URL}/${locationId}/affiliates/generate-link`,
        { locationId, entityId: groupId }
      )
    ).data
  },
  generateLead: async (locationId: string, payload: any): Promise<any> => {
    return (
      await requests().post(
        `${config.GOKOLLAB_SERVER_URL}/${locationId}/affiliate-members/generate-lead`,
        payload
      )
    ).data
  },
  validateLead: async (locationId: string, payload: any): Promise<any> => {
    return (
      await requests().post(
        `${config.GOKOLLAB_SERVER_URL}/${locationId}/affiliates/validate-lead`,
        payload
      )
    ).data
  },
  getLeaderboard: async (
    groupId: string,
    timeframe: TimeFrame | undefined,
    rankLimit: number,
    rankSkip: number
  ): Promise<any> => {
    const response = await requests().get(
      `${config.GOKOLLAB_SERVER_URL}/clientclub/leaderboards/${groupId}`,
      {
        params: {
          timeFrame: timeframe,
          rankLimit,
          rankSkip,
        },
      }
    )
    return response
  },
  getUserRankOnLeaderboard: async (
    groupId: string,
    contactId: string,
    timeframe?: TimeFrame
  ): Promise<any> => {
    const response = await requests().get(
      `${config.GOKOLLAB_SERVER_URL}/clientclub/leaderboards/${groupId}/users/${contactId}`,
      {
        params: { timeFrame: timeframe },
      }
    )

    return response
  },

  getWhiteLabelGroupContactId: async (
    marketplaceLocationId: string,
    groupId: string
  ): Promise<string> => {
    const url = `${config.GOKOLLAB_SERVER_URL}/${marketplaceLocationId}/marketplace-groups/${groupId}/wl-group-contact-id`

    const response = await requests().get(url)
    return response.data
  },
}
